import { PersonGeneral } from '@quromedical/models';
import { compact } from '@quromedical/utils';

export const getDisplayName = (general?: Partial<PersonGeneral>) => {
  if (!general) {
    return undefined;
  }
  return compact([general.prefixName, general.givenName, general.familyName]).join(' ');
};
